// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"5630bc20","780":"69eaa779"}[chunkId] + ".chunk.js";
};